import routes from 'constants/routes';
import { HomeCard } from './types';

export const emisionesCardData: HomeCard[] = [
	{
		id: 111,
		icon: '🔀',
		title: 'Mesa de cruces',
		description: 'Qué emitir con qué autorización, qué tarjeta autorizar y qué falta cobrar.',
		link: routes.operations.cardDeskBoard,
		isExternal: false,
	},
	{
		id: 101,
		icon: '💳',
		title: 'Agregar tarjeta a la cartera',
		description: 'Cargá la tarjeta en forma interna (emisiones), sin link al cliente.',
		link: routes.operations.walletAddCard,
		isExternal: false,
		requiresUruguay: true,
	},
	{
		id: 102,
		icon: '🎫',
		title: 'Tickets de vuelos y ancillaries',
		description: 'Consultá y gestioná tickets de vuelos y servicios ancillaries.',
		link: routes.operations.flightAndAncillaryTickets,
		isExternal: false,
		requiresUruguay: true,
	},
	{
		id: 103,
		icon: '✈️',
		title: 'Control de emisión de vuelos',
		description: 'Seguimiento y control del proceso de emisión de vuelos.',
		link: routes.operations.flightIssuingControl,
		isExternal: false,
		requiresUruguay: true,
	},
	{
		id: 104,
		icon: '💳',
		title: 'Transacciones C2A',
		description: 'Listado y gestión de transacciones card-to-airline.',
		link: routes.transactions.listV2,
		isExternal: false,
	},
	{
		id: 105,
		icon: '🏦',
		title: 'Comercios y cuotas con aerolíneas',
		description: 'Códigos de comercio y cuotas habilitadas por aerolínea.',
		link: routes.airlines.merchantAndInstallments,
		isExternal: false,
		requiresUruguay: true,
	},
	{
		id: 106,
		icon: '📋',
		title: 'Reglas de emisión de vuelos',
		description: 'Configuración de reglas para la emisión de vuelos.',
		link: routes.flightIssueRule.list,
		isExternal: false,
		requiresUruguay: true,
	},
	{
		id: 107,
		icon: '💰',
		title: 'Costos de emisión',
		description: 'Reglas y costos asociados a la emisión de vuelos.',
		link: routes.costIssuingRules.list,
		isExternal: false,
		requiresUruguay: true,
	},
	{
		id: 108,
		icon: '🛒',
		title: 'Listado de sale orders',
		description: 'Buscá y accedé a órdenes de venta.',
		link: routes.salesOrder.list,
		isExternal: false,
	},
	{
		id: 109,
		icon: '🤝🏼',
		title: 'CRM',
		description: 'Nimbux CRM y sistema de tickets.',
		link: 'https://crm.mevuelo.com/',
		isExternal: true,
	},
	{
		id: 110,
		icon: '🌐',
		title: 'Amadeus',
		description: 'Amadeus Selling Platform Connect.',
		link: 'https://www.sellingplatformconnect.amadeus.com/',
		isExternal: true,
	},
];
